import React from "react";
import { Link } from "react-router-dom";
import { Brand } from "../marketing/MarketingLayout";
import { IMAGES } from "../../lib/constants";

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen bg-surface lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden lg:block">
        <img src={IMAGES.mistyHills} alt="Food delivery partner and taxi driver" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/40 to-ink/10" />
        <div className="relative flex h-full flex-col justify-between p-12 text-surface">
          <Brand light />
          <div className="max-w-md">
            <p className="text-3xl font-bold leading-tight">Rides, food and local partners. One account across mobile and web.</p>
            <p className="mt-4 text-surface/75">Sign in with the same details you use in the KohimaTaxi mobile app.</p>
            <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-surface/15 px-4 py-1.5 text-xs font-semibold text-surface backdrop-blur" data-testid="auth-made-in-naga">
              Designed, Built &amp; Made in Naga Hills (Nagaland &middot; India)
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col px-6 py-10 sm:px-12 lg:px-16">
        <div className="lg:hidden"><Brand /></div>
        <div className="my-auto w-full max-w-md py-10 lg:mx-auto">
          <h1 className="text-3xl font-bold tracking-tight text-ink">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-ink-soft">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 text-sm text-ink-soft">{footer}</div>}
        </div>
        <p className="text-xs text-ink-muted">
          By continuing you agree to our <Link to="/terms" className="underline underline-offset-2">Terms</Link> and <Link to="/privacy" className="underline underline-offset-2">Privacy Policy</Link>.
        </p>
      </div>
    </div>
  );
}
